<script>
    // import Column from "./Column.svelte";
    // import Grid from "./Grid.svelte";
    import Card from "./Card.svelte";
    import ElementChart from "./ElementChart.svelte";
    import ElementTable from "./ElementTable.svelte";

    export let elementData; // element

    // console.log('ElementReport elementData', elementData);
    
</script>

<section class="section elementReport {elementData.columnSpan}"
    style="grid-column-start: {elementData.columnStart}; grid-column-end: span {elementData.columnSpan};"
    >
    {#if elementData.title}
        <h3>{elementData.title}</h3>
    {/if}
    {#if elementData.report.panelResult}
        {#if elementData.report.panelResult.grid.gridColumns.length >= 1}
            <Card
                content = {elementData.report.panelResult.grid.gridContent}
                contentBgColour = {elementData.report.panelResult.grid.contentBgColour}
                contentTextColour = {elementData.report.panelResult.grid.contentTextColour}
            />
        {/if}
    {/if}
    {#if elementData.report.report.type == 'chart'}
        <ElementChart
            elementData = {elementData}
        />
    {/if}
    {#if elementData.report.report.type == 'table'}
        <ElementTable
            elementData = {elementData}
            />
    {/if}
</section>

<style>
    /* .columnContent {
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        gap: 10px;
    } */
</style>